import {Column, Group, TID} from "./Table";
import {cellToString} from "./TableCsvExport";

// matches the min width enforced by the drag handle
const minColumnWidth = 50;

// the resize divider sits beside the header cell and shares the column width
const headerDividerWidth = 4;
const headerIconWidth = 18;

// rounding slack so sub-pixel text widths never wrap
const slack = 1;

// autoSizeColumnWidth returns the column width that fits the widest row text
// across all groups (not only the rows currently scrolled into view) and the
// header label. Text is laid out in a hidden element that carries the real
// cell/header class so font, letter-spacing, padding and borders match.
export function autoSizeColumnWidth<T extends TID>(props: {
    groups: Group<T>[];
    column: Column<T>;
    cellClassName: string;
    headerEl: HTMLElement | null;
    headerIcons: number;
}): number {
    const host = props.headerEl?.parentElement || document.body;

    const lines: string[] = [];
    props.groups.map(g => g.rows.map(row => {
        cellToString(row, props.column).split("\n").map(line => lines.push(line));
        return null;
    }));

    let width = measureLines(host, props.cellClassName, lines);

    if(props.headerEl && !props.column.renderName) {
        const headerWidth = measureLines(host, props.headerEl.className, [props.column.name])
            + headerDividerWidth + props.headerIcons * headerIconWidth;
        width = Math.max(width, headerWidth);
    }

    return Math.max(width + slack, minColumnWidth);
}

// measureLines returns the border-box width of the widest line when laid out
// without wrapping inside an element with the given class
function measureLines(host: HTMLElement, className: string, lines: string[]): number {
    const el = document.createElement("div");
    el.className = className;
    el.style.position = "absolute";
    el.style.visibility = "hidden";
    el.style.pointerEvents = "none";
    el.style.width = "max-content";
    el.style.minWidth = "0";
    el.style.maxWidth = "none";
    el.style.flex = "none";
    el.style.display = "block";
    el.style.whiteSpace = "pre";

    lines.map(line => {
        const div = document.createElement("div");
        div.textContent = line;
        el.appendChild(div);
        return null;
    });

    host.appendChild(el);
    try {
        return Math.ceil(el.getBoundingClientRect().width);
    } finally {
        host.removeChild(el);
    }
}
